export default __webpack_public_path__ + "static/media/LoginImages2x.099df9c5.png";